import { useEffect } from "react";
import { useOrganisation } from "./services"
import { useNavigation } from "./useNavigation";
import { NavigationPathsEnum } from "@utilities/enums";

export const useAllowedAccess = ()=> {

    const { isUserAdmin } = useOrganisation();
    const { navigateTo } = useNavigation();

    useEffect(()=> {
        if(!isUserAdmin){
            navigateTo(NavigationPathsEnum.SHOP);
        }
    }, [isUserAdmin]);

}
